export const reportMessages = Object.freeze({
  accessCodesUsedByAccountGenerateFailed:
    "We couldn't generate the report. Please try again.",
});
